"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingDots = void 0;
// (C) 2020 GoodData Corporation
var LoadingDots_1 = require("./LoadingDots");
Object.defineProperty(exports, "LoadingDots", { enumerable: true, get: function () { return LoadingDots_1.LoadingDots; } });
//# sourceMappingURL=index.js.map